import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description TableFilter icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { TableFilter } from '@sravni/design-system-icons'
 *
 * <TableFilter />
 * ```
 */
var TableFilter = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "TableFilter", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.736 4h-12l4.8 5.975v4.762l2.4 1.263V9.975L16.736 4Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { TableFilter };
//# sourceMappingURL=TableFilter.js.map
